<template>
  <div class="collage-photo-item__image-container" :class="{'video': isVideo, 'is-loading': !loaded}">
    <img v-lazy="media.thumb_url"
         class="collage-photo-item__image"
         :class="{'video': isVideo}"
         :alt="media.id"
         @load="loaded = true">
    <Icon v-if="isVideo" name="play" :width="20" class="play"/>
  </div>
</template>

<script>
import {mediaTypes} from "@/domain/galleries/constants";

export default {
  name: "ImageItem",
  props: {
    media: {
      type: [Object, Number],
      required: true
    }
  },
  data() {
    return {
      loaded: false
    }
  },
  computed: {
    isVideo() {
      return this.media.media_type === mediaTypes.VIDEO;
    }
  }
}
</script>

<style scoped>
</style>